import { useLayoutEffect } from 'react';
import { Helmet } from "react-helmet"

import {
		Container,
		Grid
	} from 'semantic-ui-react'
import { Link, useLocation } from 'react-router'
import GetStarted from './GetStarted';
import { PrepUnavailable } from "./PrepUnavailable";

const LearnButton = ({link='/', secondary=false}) => <div className='learn'><Link to={link}><svg
xmlns="http://www.w3.org/2000/svg"
width="330.15"
height="67.052"
viewBox="0 0 330.15 67.052"
>
<g data-name="Learn More BTN" transform="translate(1.5 1.49)">
  <path
	fill="#0096ec"
	stroke={secondary?"#2C6A6A":"#fff"}
	strokeWidth="3"
	d="M19.005 60.494c-6.282-1.211-12.461-4.432-15.8-9.888-2.576-4.207-3.24-9.316-3.2-14.25.053-6.83 1.428-13.844 5.266-19.494C9.927 10.006 17.777 5.843 25.847 3.955S42.304 2.209 50.59 2.36l114.095 2.085c12.875.236 25.773.47 38.612-.515 12.1-.928 24.1-2.938 36.218-3.607 23.115-1.275 42.287 1.407 65.154 5.015 5.619.887 11.773 2.07 15.334 6.506 2.894 3.6 6.573 9.523 7.009 14.125 1.17 12.316-6.006 27.515-16.366 31.956-4.694 2.012-9.918 2.305-15.018 2.559-90.13 4.491-165.9 4.6-256.1 2.016-7.618-.448-14.241-.796-20.523-2.006z"
	data-name="Path 317"
  ></path>
  <g data-name="Learn More BTN" transform="translate(72.067 21.606)">
	<text
	  fill="#fff"
	  data-name="Learn more"
	  fontFamily="LemonYellowSun, Lemon Yellow Sun"
	  fontSize="35"
	  letterSpacing=".025em"
	  transform="translate(58 26)"
	>
	  <tspan x="-68.022" y="0">
		Learn more
	  </tspan>
	</text>
	<g data-name="1" transform="translate(160.426 2.213)">
	  <path
		fill="#fff"
		d="M11.287 0L9.235 2.052 17 9.821H0v2.932h17l-7.765 7.769 2.052 2.052 11.287-11.287z"
		data-name="Path 10"
	  ></path>
	</g>
  </g>
</g>
</svg></Link></div>

const PBSBtn = () => {
	return ( <a href='https://www.pbs.gov.au/medicine/item/10347N-11146P-11149T' target="_blank" className='pbs'><svg
		xmlns="http://www.w3.org/2000/svg"
		width="391.653"
		height="67.052"
		viewBox="0 0 391.653 67.052"
	  >
		<g data-name="Group 237" transform="translate(-976.461 -4856.75)">
		  <path
			fill="#0096ec"
			stroke="#fff"
			strokeWidth="3"
			d="M1000.538 4918.735c-7.463-1.211-14.8-4.432-18.772-9.888-3.061-4.207-3.849-9.316-3.8-14.25.063-6.83 1.7-13.844 6.256-19.494 5.532-6.856 14.857-11.019 24.444-12.907s19.551-1.746 29.395-1.595l135.544 2.085c15.295.236 30.618.47 45.871-.515 14.373-.928 28.634-2.938 43.027-3.607 27.46-1.275 50.236 1.407 77.4 5.015 6.676.887 13.986 2.07 18.217 6.506 3.438 3.6 7.809 9.523 8.327 14.125 1.39 12.316-7.135 27.515-19.442 31.956-5.576 2.012-11.782 2.305-17.841 2.559-107.074 4.491-197.082 4.6-304.246 2.016-9.049-.448-16.917-.796-24.38-2.006z"
			data-name="Path 317"
		  ></path>
		  <g data-name="Learn More BTN" transform="translate(1016.777 4876.847)">
			<text
			  fill="#fff"
			  data-name="view PBS prep pricing"
			  fontFamily="LemonYellowSun, Lemon Yellow Sun"
			  fontSize="35"
			  letterSpacing=".025em"
			  transform="translate(129 29)"
			>
			  <tspan x="-128.503" y="0">
				view PBS prep pricing
			  </tspan>
			</text>
			<g data-name="1" transform="translate(288.426 5.213)">
			  <path
				fill="#fff"
				d="M11.287 0L9.235 2.052 17 9.821H0v2.932h17l-7.765 7.769 2.052 2.052 11.287-11.287z"
				data-name="Path 10"
			  ></path>
			</g>
		  </g>
		</g>
	  </svg></a> );
}

const GetStartedBtn = ({label,big}) => {
	return <Link className={['get-started action',big?'big':''].join(' ')} to='/application-progress'><GetStarted label={label} /></Link>;
}
 

	
	
const Homepage = () => {
	const {hash} = useLocation()
	
	useLayoutEffect(_=>{
		if (hash)
			document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth'}) 
		else 
			document.querySelector('.home')?.scrollIntoView({ behavior: 'smooth'}) 
	},[hash])

	const user_in = app.user?.user_in
	const img_path = "https://storage.googleapis.com/instant-med-public/iprep/";

	if (!app.settings.iprep_avail) return <PrepUnavailable />

	return (
		<div className="home">
			<Helmet>
				<title>Home</title>
			</Helmet>
			<section className="hero primary">
				<Container>
					<h1 className="hero">
						<div>HIV Prevent</div>
						<img
							src={img_path+"heart-vector.png"}
							alt="HIV Prevent"
							style={{margin:'1em auto 0',maxHeight:'180px'}}
						/>
					</h1>
					{app.user.user_in && <GetStartedBtn big/>}
					<h1 className="alt">
						Your partner in P<small>r</small>EP{" "}
						<em>Easy. Online. Discreet. Delivered</em>
					</h1>
				</Container>
			</section>

			<section className="hero secondary">
				<Container>
					<h1>
						Protect yourself without having to{" "}
						<span className="bubble">
							<span>explain</span>
						</span>{" "}
						yourself
					</h1>
					<p>
						Talking about sexual health in the LGBTQI community can
						be awkward, intimidating and in most situations
						difficult. If you’re medically eligible for PrEP, it
						shouldn’t be of the opinion of your doctor to stop you from
						gaining access to HIV preventative medication, so that
						you can lead a normal sexually active lifestyle.
					</p>
					<LearnButton secondary link="/prep/process-overview" />
				</Container>
			</section>

			<section className="hero primary">
				<span id="what-is-prep" className="anc" />
				<Container>
					<h1>
						What is P<small>r</small>EP?
					</h1>
					<p>PrEP (pre-exposure prophylaxis) is medicine people at risk for HIV take to prevent getting HIV from sex or injection drug use. When taken as prescribed, PrEP is highly effective for preventing HIV. PrEP does not protect against other STIs and must be taken every day to be effective. If taken as instructed it can be over 90% effective in preventing the transmission of HIV. </p>
					<LearnButton link="/prep/what-is-prep" />
				</Container>
			</section>

			<section className="hero secondary">
				<span id="process-overview" className="anc" />
				<Container>
					<h2>The amazing route!</h2>

					<Grid columns={3} stackable className="routes">
						<Grid.Row>
							<Grid.Column>
								<Grid stackable>
									<Grid.Row>
										<Grid.Column width={10}>
											<img
												src={img_path+"sign-up-green@2x.png"}
												alt="Sign up"
												className="d-icon"
											/>
											
										</Grid.Column>
										<Grid.Column
											width={6}
											textAlign="center"
											className='arrow'
										>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="50"
												height="33.304"
												viewBox="0 0 90.339 33.304"
											>
												<g
													fill="none"
													stroke="#4fbab1"
													strokeWidth="3"
													data-name="Group 211"
													transform="scale(-1) rotate(83.98 1514.024 942.687)"
												>
													<path
														d="M396.957 2348.526s-4.433 34.144-3.065 60.668 3.065 25 3.065 25"
														data-name="Path 325"
													></path>
													<path
														d="M408.434 2418.406s-8.352 15.66-12.133 16.949-10.734-4.465-16.641-16.949"
														data-name="Path 326"
													></path>
												</g>
											</svg>
										</Grid.Column>
									</Grid.Row>
								</Grid>
								<h3>Step 1</h3>
								<p>Create an account or sign in with your existing HIV Prevent or InstantScripts account</p>
							</Grid.Column>
							<Grid.Column>
								<Grid columns={2} stackable>
									<Grid.Row>
										<Grid.Column width={10}>
											<img
												src={img_path+"Group 283@2x.png"}
												alt="Pathology"
												className="d-icon"
											/>
											
										</Grid.Column>
										<Grid.Column
											width={6}
											textAlign="center"
											className='arrow'
										>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="50"
												height="34.093"
												viewBox="0 0 90.395 34.093"
											>
												<g
													fill="none"
													stroke="#4fbab1"
													strokeWidth="3"
													data-name="Group 214"
													transform="rotate(81 41.17 50.072)"
												>
													<path
														d="M17.297 87.007s-4.433-34.144-3.065-60.669 3.065-25 3.065-25"
														data-name="Path 325"
													></path>
													<path
														d="M28.773 17.126S20.422 1.466 16.641.177 5.906 4.642 0 17.126"
														data-name="Path 326"
													></path>
												</g>
											</svg>
										</Grid.Column>
									</Grid.Row>
								</Grid>
								<h3>Step 2</h3>
											<p>
											Complete a short digital consultation for a pathology test that is required prior to obtaining PrEP
											</p>
							</Grid.Column>
							<Grid.Column>
								<img
									src={img_path+"heart-vector.png"}
									alt="Delivery"
									className="d-icon"
								/>
								<h3>Step 3</h3>
								<p>
								Once we have received your pathology results, a doctor will review them to assess your eligibility for PrEP. If successful, we will send your prescription within 1-2 days
								</p>
							</Grid.Column>
						</Grid.Row>
					</Grid>

					

					<LearnButton link="/prep/process-overview" secondary />
				</Container>
			</section>
			<section className="hero primary">
				<span id="telehealth" className="anc" />
				<Container>
					<h1>Our Doctors are here to help</h1>
					<p>
						Getting started with PrEP can be daunting, and that's
						why our doctors are available to answer your questions
						through our Telehealth consultation, via InstantScripts.
						All our doctors are registered and based in Australia.
					</p>
					<LearnButton link="/med/DocConsCov" />
				</Container>
			</section>

			<section className="hero primary">
				<span id="how-much" className="anc" />
				<Container>
					<h1>Sounds good. How much is it?</h1>
					<Grid columns={3} stackable className="prices">
						<Grid.Row>
							<Grid.Column tablet={16} computer={5}>
								<div className="price">
									<h3>Concession card holders</h3>
									<div>
										<strong>
											$19.80 <small>per 3 months</small>
										</strong>
										<p>+ $20 Short Digital consultation</p>
										<p>Excluding delivery</p>
										<GetStartedBtn label="Order Now"/>
									</div>
								</div>
							</Grid.Column>
							<Grid.Column tablet={16} computer={5}>
								<div className="price">
									<h3>Medicare card holders</h3>
									<div>
										<strong>
											$123.90 <small>per 3 months</small>
										</strong>
										<p>+ $20 Short Digital consultation</p>
										<p>Excluding delivery</p>
										<GetStartedBtn label="Order Now"/>
									</div>
								</div>
							</Grid.Column>
							<Grid.Column tablet={16} computer={5}>
								<div className="price">
									<h3>Private pricing</h3>
									<div>
										<strong>
											$189.99 <small>per 3 months</small>
										</strong>
										<p>+ $20 Short Digital consultation</p>
										<p>Excluding delivery</p>
										<GetStartedBtn label="Order Now"/>
									</div>
								</div>
							</Grid.Column>
						</Grid.Row>
					</Grid>
					<p>&nbsp;</p>
					
					
					<p>&nbsp;</p>

					<p>
						<PBSBtn />
					</p>
				</Container>
			</section>

			<section className="hero secondary">
				<span id="who-are-we" className="anc" />
				<Container>
					<h1>Sexual Health Management Simplified.</h1>
					<p>
						We’re an online healthcare services team dedicated to
						proving private and simplified access to pre-exposure
						prophylaxis (PrEP). Our mission is to educate, guide and
						support Australians of any age, demographic or sexual
						orientation through their sexual health journey.
					</p>
					<Grid columns={3} stackable className="features">
						<Grid.Row>
							<Grid.Column>
								<svg
									data-name="Privacy icon"
									xmlns="http://www.w3.org/2000/svg"
									width={76.28}
									height={97.42}
									viewBox="0 0 76.28 97.42"
								>
									<path
										data-name="Path 270"
										d="M12.796 97.42a12.81 12.81 0 01-12.8-12.8V54.649a12.8 12.8 0 0110.288-12.6l6.223-1.246V21.63a21.629 21.629 0 1143.257 0v1.578a2.068 2.068 0 11-4.135 0V21.63a17.6 17.6 0 00-35.2 0v18.384l15.1-3.018a10.733 10.733 0 014.961-.008l25.384 5.057a13.2 13.2 0 0110.4 12.625v29.955a12.812 12.812 0 01-12.8 12.8zm25.239-56.476a8.04 8.04 0 00-1.706.129l-25.346 5.048a8.61 8.61 0 00-7.058 8.528v30.079a8.774 8.774 0 008.764 8.764h50.692a8.774 8.774 0 008.764-8.764V54.649a8.835 8.835 0 00-7.046-8.528L39.74 41.073a8.042 8.042 0 00-1.705-.129z"
										fill="#4fbab1"
									/>
									<path
										data-name="Path 271"
										d="M38.137 82.063a2.1 2.1 0 01-2.068-2.068V69.678l-.805-.278a8.79 8.79 0 012.769-17.134 9.072 9.072 0 019.009 8.843 8.9 8.9 0 01-6.041 8.3l-.8.282v10.304a2.1 2.1 0 01-2.064 2.068zm-.1-25.766a4.768 4.768 0 104.766 4.77 4.718 4.718 0 00-4.774-4.77z"
										fill="#4fbab1"
									/>
								</svg>
								<h3>Privacy</h3>
								<p>
									No more stress fronting up to a ‘gay
									friendly’ doctor to see whether or not you can
									access PrEP.
								</p>
								<p>
									No need to wait in line at a chemist to pick
									up your script.
								</p>
							</Grid.Column>
							<Grid.Column>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width={100}
									height={65}
									viewBox="0 0 100 65"
									preserveAspectRatio="xMaxYMax"
								>
									<path
										data-name="Convenience van icon"
										d="M20 51.667A3.333 3.333 0 1023.333 55 3.334 3.334 0 0020 51.667m60 0A3.333 3.333 0 1083.333 55 3.334 3.334 0 0080 51.667M75 40h-3.333a1.667 1.667 0 100 3.333H75A1.667 1.667 0 1075 40m21.667 13.333h-6.805c-.007-.038-.022-.073-.03-.111a10.04 10.04 0 00-.387-1.479 4.19 4.19 0 00-.1-.26 10.1 10.1 0 00-.637-1.375c-.036-.063-.076-.123-.113-.186a10.02 10.02 0 00-.9-1.292l-.029-.032a9.919 9.919 0 00-1.1-1.116c-.045-.04-.085-.082-.13-.119a10.034 10.034 0 00-1.239-.886c-.073-.045-.145-.09-.22-.134a9.923 9.923 0 00-1.358-.653 12.438 12.438 0 00-.248-.092 10.181 10.181 0 00-1.5-.415c-.066-.013-.133-.02-.2-.031a9.338 9.338 0 00-3.356 0c-.067.011-.134.018-.2.031a10.181 10.181 0 00-1.5.415c-.083.03-.165.06-.248.092a9.923 9.923 0 00-1.358.653c-.075.044-.147.089-.22.134a10.034 10.034 0 00-1.239.886c-.045.037-.085.079-.13.119a9.919 9.919 0 00-1.1 1.116l-.029.032a9.9 9.9 0 00-.9 1.293c-.037.062-.077.122-.113.185a10.04 10.04 0 00-.637 1.375 8.189 8.189 0 01-.1.26 10.04 10.04 0 00-.387 1.479c-.008.038-.023.073-.03.111H29.862c-.007-.038-.022-.073-.03-.111a10.04 10.04 0 00-.387-1.479c-.03-.086-.063-.173-.095-.26a10.1 10.1 0 00-.637-1.375c-.036-.063-.076-.123-.113-.186a10.021 10.021 0 00-.9-1.292l-.029-.032a9.919 9.919 0 00-1.1-1.116c-.045-.04-.085-.082-.13-.119a10.034 10.034 0 00-1.239-.886c-.073-.045-.145-.09-.22-.134a9.923 9.923 0 00-1.358-.653 12.438 12.438 0 00-.248-.092 10.181 10.181 0 00-1.5-.415c-.066-.013-.133-.02-.2-.031a9.338 9.338 0 00-3.356 0c-.067.011-.134.018-.2.031a10.181 10.181 0 00-1.5.415c-.083.03-.165.06-.248.092a9.923 9.923 0 00-1.358.653c-.075.044-.147.089-.22.134a10.034 10.034 0 00-1.239.886c-.045.037-.085.079-.13.119a9.919 9.919 0 00-1.1 1.116l-.029.032a9.9 9.9 0 00-.9 1.293c-.037.062-.077.122-.113.185a10.04 10.04 0 00-.637 1.375c-.032.087-.065.174-.095.26a10.04 10.04 0 00-.387 1.479c-.008.038-.023.073-.03.111h-6.8V35h45.004a18.351 18.351 0 0018.329-18.328v-.005H82.4a1.668 1.668 0 011.618 1.261l3.852 15.4H75.45a2.118 2.118 0 01-2.117-2.116v-7.879a1.667 1.667 0 00-3.333 0v7.884a5.456 5.456 0 005.45 5.45h14.228l6.989 2.8zM80 61.667A6.667 6.667 0 1186.667 55 6.674 6.674 0 0180 61.667zm-60 0A6.667 6.667 0 1126.667 55 6.674 6.674 0 0120 61.667zM3.333 3.333h60v13.339a15.012 15.012 0 01-14.995 14.995H3.333zM97.9 36.367l-6.493-2.6-4.159-16.649a5 5 0 00-4.848-3.785H66.667v-10A3.337 3.337 0 0063.333 0h-60A3.337 3.337 0 000 3.333v50a3.337 3.337 0 003.333 3.334h6.817a9.988 9.988 0 0019.7 0h40.3a9.988 9.988 0 0019.7 0h6.817A3.337 3.337 0 00100 53.333V39.462a3.315 3.315 0 00-2.1-3.1zM10 11.667h46.667a1.667 1.667 0 000-3.334H10a1.667 1.667 0 000 3.334m0 6.666h43.333a1.667 1.667 0 100-3.333H10a1.667 1.667 0 100 3.333m41.667 5A1.665 1.665 0 0050 21.667H10A1.667 1.667 0 1010 25h40a1.665 1.665 0 001.667-1.667"
										fill="#4fbab1"
									/>
								</svg>
								<h3>Convenience</h3>
								<p>
									Order PrEP through HIV Prevent and your
									medication is delivered right to your door.
								</p>
								<p>Free, fast delivery nation-wide.</p>
							</Grid.Column>
							<Grid.Column>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="100.693"
									height="69.622"
									data-name="Instant Scripts icon"
									viewBox="0 0 100.693 69.622"
								>
									<path
										fill="#4fbab1"
										d="M297.579 1057.369a2.385 2.385 0 003.379 0L322 1036.328l21.041 21.041a2.385 2.385 0 003.379 0l21.182-21.182a15.4 15.4 0 004.168-15.4 21.969 21.969 0 00-14.876-14.876 15.4 15.4 0 00-15.4 4.168L322 1029.568l-19.5-19.492c-7.672-7.672-18.255-5.123-24.744 1.366s-9.038 17.072-1.366 24.744zm47.292-43.913a10.673 10.673 0 0110.795-2.931 17.214 17.214 0 0111.492 11.492 10.663 10.663 0 01-2.931 10.794l-19.493 19.489-19.355-19.355zm-63.729 1.366a15.75 15.75 0 018.914-4.633 10.637 10.637 0 019.076 3.267l19.492 19.492-19.356 19.352-19.492-19.492c-5.713-5.708-3.297-13.328 1.366-17.987z"
										data-name="Path 269"
										transform="translate(-271.669 -1005.319)"
									></path>
									<circle
										cx="3.483"
										cy="3.483"
										r="3.483"
										fill="#4fbab1"
										data-name="Ellipse 2"
										transform="translate(46.849 40.823)"
									></circle>
									<circle
										cx="3.483"
										cy="3.483"
										r="3.483"
										fill="#4fbab1"
										data-name="Ellipse 3"
										transform="translate(46.849 62.656)"
									></circle>
									<circle
										cx="3.483"
										cy="3.483"
										r="3.483"
										fill="#4fbab1"
										data-name="Ellipse 4"
										transform="translate(57.765 51.739)"
									></circle>
									<circle
										cx="3.483"
										cy="3.483"
										r="3.483"
										fill="#4fbab1"
										data-name="Ellipse 5"
										transform="translate(35.933 51.739)"
									></circle>
								</svg>
								<h3>Trust</h3>
								<p>
									HIV Prevent is powered by InstantScripts; an
									Australian leader in online healthcare
									services, with over 900+ 5-star reviews
									online.{" "}
								</p>
								<p>
									All our doctors are registered and gay
									friendly.{" "}
								</p>
							</Grid.Column>
						</Grid.Row>
					</Grid>
					<LearnButton link="/prep/who-are-we" secondary />
				</Container>
			</section>
		</div>
	);
}

export default Homepage;
